function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74 86"
}, props), React.createElement("path", {
  d: "M45.223 10.133c-.058 1.854-.547 6.318 1.767 9.555 3.715 5.196 11.751 16.892 13.875 19.907.635.901 1.066 1.906 1.176 2.964.182 1.762-.438 4.085-4.453 5.051-6.708 1.619-7.825 5.117-7.321 7.578.503 2.46 2.24 6.52-2.3 8.479M36.984 65.814s5.022-2.284 8.898-2.29c2.992 0 4.912 2.924 3.219 5.13-.015.02-.037.045-.051.065 0 0-.446.594-.935 1.527-1.014 1.952-1.138 4.158-.547 6.246.744 2.618.533 7.33-10.584 7.33h-6.562",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M45.56 1.693s11.847 13.093-27.044 13.818c-3.7.072-7.299.437-10.284 1.43-4.803 1.592-9.416 4.9-5.884 11.702M16.148 84.532c2.3-8.446 2.716-18.908 2.65-26.316-.044-5.287 4.54-9.68 10.438-10.032l10.124-.607s10.336-.137 13.256-6.175",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M5.46 84.534c3.183-7.108 3.359-16.187 3.344-24.3-.022-11.272 10.27-20.39 22.876-20.39h6.204s7.665.111 8.884-4.072",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M37.954 34.437h-.382l-.007.007h-6.698c-3.24 0-6.408.43-9.426 1.256 2.685-2.086 5.923-2.987 8.43-3.642h0c2.927-.767 4.018-3.452 4.39-5.76.104-.638.158-1.279.18-1.89a3192.999 3192.999 0 016.395 9.758c-.94.18-1.91.271-2.882.271zM36.976 78.907h-1.134c2.116-1.05 3.761-2.212 4.997-3.266.375-.32.711-.628 1.012-.921a13.69 13.69 0 00.506 3.02h0l.003.01c.037.123.062.246.073.349-.034.018-.075.04-.126.064-.213.1-.535.219-.993.331-.915.225-2.315.413-4.338.413zm6.328-.22l-.01.01.01-.01z",
  fill: "#fff",
  stroke: "#5FB9D7",
  strokeWidth: "2"
}), React.createElement("path", {
  d: "M65.766 50.318l7.116 6.305M63.516 55.305l6.138 6.892M58.266 57.77l2.92 4.079",
  stroke: "#5FB9D7",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));